// https://api.exchangeratesapi.io/2021-01-01?base=USD

export const currencyData: Record<string, number> = {
    CAD: 1.264,
    HKD: 7.796,
    ISK: 129.79,
    PHP: 51,
    DKK: 6.539,
    HUF: 324.71,
    CZK: 21.872,
    GBP: 0.733,
    RON: 4.351,
    SEK: 9.05,
    IDR: 14242,
    INR: 74.514,
    BRL: 5.571,
    RUB: 74.792,
    HRK: 6.61,
    JPY: 115.108,
    THB: 33.195,
    CHF: 0.912,
    EUR: 0.879,
    MYR: 4.177,
    BGN: 1.718,
    TRY: 13.321,
    CNY: 6.356,
    NOK: 8.818,
    NZD: 1.462,
    ZAR: 15.951,
    USD: 1,
    MXN: 20.497,
    SGD: 1.349,
    AUD: 1.376,
    ILS: 3.113,
    KRW: 1188.88,
    PLN: 4.035,
}
